import { superAppApiFetch } from '~/utils/superAppApiFetch'
import { superAppApi } from './routes'

export const getUser = async () => superAppApiFetch(superAppApi.account)
